import { useMemo } from 'react'
import { DmAndGdmModel, useMyUserId } from 'use-towns-client'

export const useMatchingMessages = (params: {
    dmChannels: DmAndGdmModel[]
    selectedUserArray: string[]
}) => {
    const myUserId = useMyUserId()
    const { dmChannels, selectedUserArray } = params
    const numSelectedUsers = selectedUserArray.length

    const inclusiveMatches = useMemo(
        () =>
            dmChannels.filter((dm) => {
                if (numSelectedUsers > 1) {
                    return selectedUserArray.every((id) => dm.userIds.includes(id))
                }
                return false
            }),
        [dmChannels, numSelectedUsers, selectedUserArray],
    )

    const matchingDM = useMemo(
        () =>
            numSelectedUsers === 1 &&
            dmChannels.find((c) => !c.isGdm && c.userIds.includes(selectedUserArray[0])),
        [dmChannels, numSelectedUsers, selectedUserArray],
    )

    const exactMatchingGDM = useMemo(
        () =>
            numSelectedUsers > 1
                ? inclusiveMatches.filter(
                      (c) =>
                          c.userIds.length === selectedUserArray.length &&
                          c.userIds.every((u) => selectedUserArray.includes(u) || u === myUserId),
                  )
                : [],
        [inclusiveMatches, myUserId, numSelectedUsers, selectedUserArray],
    )

    const partialMatchingGDM = useMemo(
        () =>
            numSelectedUsers > 1
                ? inclusiveMatches.filter(
                      (c) =>
                          c.userIds.length > selectedUserArray.length + 1 &&
                          selectedUserArray.every((id) => c.userIds.includes(id)),
                  )
                : [],
        [inclusiveMatches, numSelectedUsers, selectedUserArray],
    )

    return {
        inclusiveMatches,
        matchingDM,
        exactMatchingGDM,
        partialMatchingGDM,
    }
}
